import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSubdomain = _resolveComponent("AppSubdomain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppSubdomain, {
      name: "Marissa Pedersen",
      propMessage: "www.postcardstoseattle.com",
      destination: "https://postcardstoseattle.com",
      imagefile: "marissa_and_jp.jpg",
      class: "layout-item"
    }),
    _createVNode(_component_AppSubdomain, {
      name: "Jasper Pedersen",
      propMessage: "I'm a baby",
      destination: "https://jasper.pedersen.io",
      imagefile: "jasper_nightlight.jpg",
      class: "layout-item"
    }),
    _createVNode(_component_AppSubdomain, {
      name: "Kieran Pedersen",
      propMessage: "www.postcardstoseattle.com",
      destination: "https://postcardstoseattle.com",
      imagefile: "marissa_and_jp.jpg",
      class: "layout-item"
    })
  ]))
}